export const BUILDING_TYPE = {
  RESIDENTIAL: 1,
  HOTEL: 2
};

export const MAX_CONTACTS_PER_BUILDING = 4;

// Autograph: Cobalt (dev: 52712, prod: 291)
const COBALT_AMENITY_BOOKING_BUILDING_IDS = [52712, 291, 320];

export const isHotelBuilding = (buildingType) => {
  return buildingType === BUILDING_TYPE.HOTEL;
};

export const isCobaltAmenityBookingBuilding = (buildingId) =>
  COBALT_AMENITY_BOOKING_BUILDING_IDS.includes(Number(buildingId));
export const waterLeakTempFixOrgIds = [114, 118, 119, 120, 125, 140];
export const waterLeakTempFixUnitIds = [1177513, 1177471, 1177182, 1171765, 1171764, 1172075, 1178461, 1178463];
